// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"583":"f7ec2408","692":"44f2a866"}[chunkId] + ".chunk.css";
};